module.exports = __webpack_public_path__ + "img/app_download_3.0bbebf07.png";